import cheerio from "cheerio"

export default (str: string, max = 150) =>
  trimTileCopy(excerpts(str, { characters: max }), max)

export const trimTileCopy = (str: string, max: number) => {
  if (str.length > max) {
    const sub = str.substring(0, max)
    const lastIndex = sub.lastIndexOf(" ")
    return `${sub.substr(0, lastIndex)}...`
  }
  return str
}

// This code below is essentually what the npm package excerpts does, but is now
// not compatible with our build due to nested deprecated dependencies.
// https://github.com/gnowoel/excerpts
export interface ExcerptsOptions {
  append?: string
  words?: number
  characters?: number
}

export const excerpts = (html: string, opts: ExcerptsOptions) => {
  const options = prepare(opts)
  const text = cheerio
    .load(html)
    .root()
    .text()
    .trim()
    .replace(/(\r\n|\r|\n|\s)+/g, " ")

  let excerpt = ""

  if (options.characters) {
    excerpt = text.slice(0, opts.characters)
  }
  if (options.words) {
    excerpt = text.split(" ").slice(0, opts.words).join(" ")
  }
  if (excerpt.length < text.length) {
    excerpt += opts.append
  }
  return excerpt
}

const prepare = (opts: ExcerptsOptions) => {
  opts = opts || {}

  if (!opts.append) {
    opts.append = "..."
  }

  if (!opts.words && !opts.characters) {
    opts.words = 50
  }

  if (opts.words && opts.characters) {
    delete opts.characters
  }
  return opts
}
